import { createAsyncThunk,createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { EMailNotificationPreferencesStateClass } from "./interfaces/EMailNotificationPreferencesStateClass";
import fetchAPI from "../../../common/fetchAPI";
import { create } from "domain";


const initialState : EMailNotificationPreferencesStateClass ={
    isLoading:false,
    status : "idle",
    isReload : false,
    selectedRecord:{},
    eMailNotificationPreferencesList:[],
    IsEmailVerified:false
}

interface IThunkApi{
    state:{
        eMailNotificationPreferences:EMailNotificationPreferencesStateClass
    }
}

export const GetvueAccountEMailNotificationPreferencessByAccountEmployeeIdAsync = createAsyncThunk
<any,any,IThunkApi>
(
    "EMailNotificationPreferences/GetvueAccountEMailNotificationPreferencessByAccountEmployeeId",
    async (arg,thunkApi)=>{
        const response = await fetchAPI("api/v2/EmailNotifications/AccountEMailNotificationPreferencessByAccountEmployeeId/" + arg,"GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        return json;
    }

)
export const UpdateAccountEMailNotificationPreferenceAsync = createAsyncThunk
<any,{ IsEmailVerified: boolean, data: any },IThunkApi>
(
    "EMailNotificationPreferences/UpdateAccountEMailNotificationPreference",
    async (arg,thunkApi)=>{
        const { IsEmailVerified, data } = arg;
        //const {AccountEmployeeId,EmployeeTimeZoneId,...argWithoutId} = arg;
        const response = await fetchAPI("api/EMailNotificationPreferences/UpdateAccountEMailNotificationPreference/"+IsEmailVerified ,"POST",data,true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        return json;
    }
)


const eMailNotificationPreferencesSlice = createSlice({
    name:"eMailNotificationPreferences",
    initialState,
    reducers:{
        resetSelectedRecordObjectInState:(state)=>{
            state.selectedRecord = {}
        },
        checkedState: (state, action) => {
            const currentindex = state.eMailNotificationPreferencesList.findIndex((item) => item.AccountEMailNotificationPreferenceId == action.payload);
            const newArray = [...state.eMailNotificationPreferencesList];
            newArray[currentindex] = { ...newArray[currentindex], Enabled: true };
            state.eMailNotificationPreferencesList = newArray;       
        },
        unCheckedState: (state, action) => {
            const currentindex = state.eMailNotificationPreferencesList.findIndex((item) => item.AccountEMailNotificationPreferenceId == action.payload);
            const newArray = [...state.eMailNotificationPreferencesList];
            newArray[currentindex] = { ...newArray[currentindex], Enabled: false };
            state.eMailNotificationPreferencesList = newArray;       
        },
    },
   
    extraReducers:(builder) =>{
        builder
        .addCase(GetvueAccountEMailNotificationPreferencessByAccountEmployeeIdAsync.pending,(state)=>{
            state.status = "loading";
        })
        .addCase(GetvueAccountEMailNotificationPreferencessByAccountEmployeeIdAsync.fulfilled,(state,{payload})=>{
            state.status = "idle";
            state.eMailNotificationPreferencesList = JSON.parse(payload.data);
            state.IsEmailVerified = payload.IsEmailVerified;
            state.isReload = false;
            state.selectedRecord = {};
            console.log('GetvueAccountEMailNotificationPreferencessByAccountEmployeeIdAsync:',payload);
        })
        .addCase(GetvueAccountEMailNotificationPreferencessByAccountEmployeeIdAsync.rejected,(state)=>{
            state.status = "failed";
        })

        .addCase(UpdateAccountEMailNotificationPreferenceAsync.pending, (state) => {
            state.status = 'loading';
        })
        .addCase(UpdateAccountEMailNotificationPreferenceAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';        
            state.isReload = true;
        })
        .addCase(UpdateAccountEMailNotificationPreferenceAsync.rejected, (state) => {
            state.status = 'failed';
        })

    }
})

export const {resetSelectedRecordObjectInState,checkedState,unCheckedState} = eMailNotificationPreferencesSlice.actions
export const EMailNotificationPreferencesState = (state : RootState)=>state.eMailNotificationPreferences
export default eMailNotificationPreferencesSlice.reducer


